import React, { useEffect, useState } from "react";
import { AppState } from "react-native";
import { useFocusEffect } from "@react-navigation/native";

function useFocusAndAppState(
  onFocus = () => {},
  onForeground = () => {},
  onBackground = () => {},
) {
  const [appState, setAppState] = useState(AppState.currentState);

  useEffect(() => {
    // Subscribe to changes in app state
    const subscription = AppState.addEventListener(
      "change",
      handleAppStateChange,
    );

    // Return a function to unsubscribe from changes in app state
    return () => {
      subscription.remove();
    };
  }, []);

  useFocusEffect(
    React.useCallback(() => {
      onFocus();
      return () => {};
    }, [onFocus]),
  );

  const handleAppStateChange = (nextAppState) => {
    setAppState(nextAppState);

    // Run your function when the app state changes to foreground or background
    if (nextAppState === "active") {
      onForeground();
    } else {
      onBackground();
    }
  };

  return appState;
}

export default useFocusAndAppState;
